import React from 'react';
import PropTypes from "prop-types";

import styles from './CustomerEmail.scss';

const CustomerEmail = ({ label, value, onClick }) => {
    return (
        <div className={styles.customer_email}>
            <label className={styles.customer_email_label}>{label}</label>
            <div className={styles.customer_email_content_box} onClick={onClick}>
                <span className={styles.customer_email_text}>{value}</span>
                <div className={styles.icon}><i className="aeh-icon-filled-pop-up"></i></div>
            </div>
        </div>
    )
}

CustomerEmail.defaultProps = {
    label: "",
    value: "",
    onClick: () => { }
}

CustomerEmail.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    onClick: PropTypes.func
}

export default CustomerEmail;